import React, { useState } from 'react';
import { bool, arrayOf, number, shape } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PlaceIcon from '@material-ui/icons/Place';
import { Image, Rate } from 'antd';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/uiHelpers';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';

import Bulldozer from '../../components/FieldChipbox/FieldChipboxImages/Bulldozer.png';
import Compaction from '../../components/FieldChipbox/FieldChipboxImages/Compaction.png';
import Crane from '../../components/FieldChipbox/FieldChipboxImages/Crane.png';
import Dumper from '../../components/FieldChipbox/FieldChipboxImages/Dumper.png';
import Excarvator from '../../components/FieldChipbox/FieldChipboxImages/Excarvator.webp';
import Forklift from '../../components/FieldChipbox/FieldChipboxImages/Forklift.png';
import Platform from '../../components/FieldChipbox/FieldChipboxImages/Platforms.png';
import Scissor from '../../components/FieldChipbox/FieldChipboxImages/Scissor lift.png';
import Telescopic from '../../components/FieldChipbox/FieldChipboxImages/Telescopic Machine.png';
import Tools from '../../components/FieldChipbox/FieldChipboxImages/Tools.avif';
import WheelLoader from '../../components/FieldChipbox/FieldChipboxImages/Wheel Loader.png';
import BANNER from './img/banner.png';
import MAIL from './img/mail.png';
import PHONE from './img/phone.png';
import ADDRESS from './img/address.png';
import LOGOY from './img/logoKBR.png';
import FB from './img/fb.png';
import IN from './img/in.png';
import INSTA from './img/insta.png';
import TW from './img/tw.png';
import RATING from './img/rating.png';

import {
  Heading,
  H2,
  H4,
  Page,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ButtonTabNavHorizontal,
  LayoutSideNavigation,
  ReviewRating,
  Button,
  LayoutSingleColumn,
  Avatar,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';

import css from './ProfilePage.module.css';
import { queryUserListings } from './ProfilePage.duck';
import { Radio } from 'antd';
import DOT from './img/dots.svg';
import SortBy from '../SearchPage/SortBy/SortBy';
import {
  groupListingFieldConfigs,
  initialValues,
  searchParamsPicker,
  validUrlQueryParamsFromProps,
  validFilterParams,
  cleanSearchFromConflictingParams,
  createSearchResultSchema,
} from '../SearchPage/SearchPage.shared';
import { isAnyFilterActive, isOriginInUse } from '../../util/search';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../util/routes';
import ReviewRatingRed from '../../components/ReviewRating/ReviewRatingRed';

const MAX_MOBILE_SCREEN_WIDTH = 768;
let userMailId = null;
let userPhoneNumber = null;
export const RatingDistributionForProvider = props => {
  const { reviews } = props;

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);

  const totalReviewsCount = reviewsOfProvider.length;
  let fiveStars = 0;
  let fourStars = 0;
  let threeStars = 0;
  let twoStars = 0;
  let oneStars = 0;
  reviewsOfProvider.map((item) => {
    switch (item.attributes.rating) {
      case 5: fiveStars++;
        break;
      case 4: fourStars++;
        break;
      case 3: threeStars++;
        break;
      case 2: twoStars++;
        break;
      case 1: oneStars++;
        break;
    }
  });

  return (
    <div className={css.ratingDistributionBox}>
      <label className={css.ratingLabel}> Rating Distribution</label>
      <div className={css.progressBarBox}>
        <div className={css.bar}>5 <progress className={css.progressBar} value={fiveStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>4 <progress className={css.progressBar} value={fourStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>3 <progress className={css.progressBar} value={threeStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>2 <progress className={css.progressBar} value={twoStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>1 <progress className={css.progressBar} value={oneStars} max={totalReviewsCount} /> </div>
      </div>
    </div>
  );
};

export const RatingDistributionForCustomer = props => {
  const { reviews } = props;

  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);

  const totalReviewsCount = reviewsOfCustomer.length;
  let fiveStars = 0;
  let fourStars = 0;
  let threeStars = 0;
  let twoStars = 0;
  let oneStars = 0;
  reviewsOfCustomer.map((item) => {
    switch (item.attributes.rating) {
      case 5: fiveStars++;
        break;
      case 4: fourStars++;
        break;
      case 3: threeStars++;
        break;
      case 2: twoStars++;
        break;
      case 1: oneStars++;
        break;
    }
  });

  return (
    <div className={css.ratingDistributionBox}>
      <label className={css.ratingLabel}> Rating Distribution</label>
      <div className={css.progressBarBox}>
        <div className={css.bar}>5 <progress className={css.progressBar} value={fiveStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>4 <progress className={css.progressBar} value={fourStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>3 <progress className={css.progressBar} value={threeStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>2 <progress className={css.progressBar} value={twoStars} max={totalReviewsCount} /> </div>
        <div className={css.bar}>1 <progress className={css.progressBar} value={oneStars} max={totalReviewsCount} /> </div>
      </div>
    </div>
  );
};


export const AsideContent = props => {
  const {
    user,
    isCurrentUser,
    companyName,
    reviews,
    showReviewsType,
    averageRating,
    listings,
    onCategoryListings,
    config,
    actualListings,
  } = props;

  const images = [
    { key: 'bulldozer', value: Bulldozer },
    { key: 'compaction', value: Compaction },
    { key: 'crane', value: Crane },
    { key: 'dumper', value: Dumper },
    { key: 'excavator', value: Excarvator },
    { key: 'forklift', value: Forklift },
    { key: 'platform', value: Platform },
    { key: 'scissor-lift', value: Scissor },
    { key: 'telescopic-machine', value: Telescopic },
    { key: 'tools', value: Tools },
    { key: 'wheel-loader', value: WheelLoader },
  ]


  const getImageForCategory = (category) => {
    const foundImage = images.find((img) => img.key === category.toLowerCase());
    return foundImage ? foundImage.value : null;
  };


  const [selectedCategory, setSelectedCategory] = useState('All');

  const userMail = user?.attributes?.profile?.email;
  const location = user?.attributes?.profile?.publicData?.location?.selectedPlace?.address;
  const phoneNumber = user?.attributes?.profile?.protectedData?.phoneNumber;

  const categories = [...new Set(actualListings.map(listing => listing.attributes.publicData.category))];

  const categoryCounts = {};
  actualListings.forEach(listing => {
    const category = listing.attributes.publicData.category;
    if (categoryCounts[category]) {
      categoryCounts[category]++;
    } else {
      categoryCounts[category] = 1;
    }
  });

  const totalCategoryCount = Object.values(categoryCounts).reduce((a, b) => a + b, 0);

  const onSelectCategory = (category) => {
    if (category === 'All') {
      setSelectedCategory('All');
      onCategoryListings(user?.id, config, null);
    } else {
      setSelectedCategory(category);
      onCategoryListings(user?.id, config, category);
    }
  };

  return (
    <div className={css.asideContent}>
      <div className={css.profileImgSection}>
        <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      </div>
      <h2 className={css.mobileHeading}>
        {companyName ? (
          <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: companyName }} />
        ) : null}
      </h2>
      <div className={css.averageRatingOnMobile}>
        <ReviewRating
          rating={averageRating}
          className={css.desktopReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
        <span className={css.averageRating}>{Math.round(averageRating) || 0}</span>
      </div>
      {isCurrentUser ? (
        <>
          <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
          </NamedLink>
          <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
          </NamedLink>
        </>
      ) : null}
      <div className={css.userMail}>
        <EmailIcon /> &nbsp;{userMail}
      </div>
      <div className={css.userMail}>
        <PlaceIcon /> &nbsp;{location}
      </div>
      <div className={css.userMail}>
        <PhoneIcon /> &nbsp;{phoneNumber}
      </div>
      <div className={css.categories}>

        <ul>
          <li onClick={() => onSelectCategory('All')} className={selectedCategory === 'All' ? css.activeTab : css.inactiveTab}>
            <span className={css.listAll}>
              All listings ({totalCategoryCount})
            </span>
          </li>
          {categories.map((category, index) => {
            const imageSrc = getImageForCategory(category);
            return (
              <li key={index}>
                <div className={selectedCategory === category ? classNames(css.radioContainer, css.activeTab) : classNames(css.radioContainer, css.inactiveTab)}>
                  {/* <Radio name="category"
                value={category}
                className={css.radio} 
                checked={selectedCategory === category}
                onChange={() => onSelectCategory(category)}>{category} ({categoryCounts[category]})</Radio> */}
                  <li onClick={() => onSelectCategory(category)} className={`${selectedCategory === category ? css.activeTabb : css.inactiveTab}`}>

                    <span>
                      {imageSrc && (
                        <img src={imageSrc} alt={category} className={css.categoryImage} width="30" height="30" />
                      )}
                    </span>
                    {/* <span> 
                <svg width="30px" height="30px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M8 3a5 5 0 100 10A5 5 0 008 3z"/></svg>
                </span> */}
                    <span className={css.categoryText}>
                      {category}
                    </span>
                    <span className={css.categoryCount}>
                      ({categoryCounts[category]})
                    </span>
                  </li>

                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};


export const RatingDistributionComponent = props => {
  const {
    showReviewsType,
    reviews
  } = props;
  return (
    <div style={{ width: '100%' }}>
      {showReviewsType === 'ofProvider' ?
        <RatingDistributionForProvider reviews={reviews} />
        : <RatingDistributionForCustomer reviews={reviews} />
      }
    </div>

  );
}

export const ReviewsErrorMaybe = props => {
  const { queryReviewsError } = props;
  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export const MobileReviews = props => {
  const { reviews,
    queryReviewsError,
    user,
    onUpdateAverageRating,
    showReviewsType,
    onUpdateShowReviewsType,
  } = props;

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;

  const userType = user?.attributes?.profile?.protectedData?.userType;

  let averageRatingOfProvider;
  let averageRatingOfCustomer;

  if (reviewsOfProvider.length == 0) {
    averageRatingOfProvider = 0;
  } else if (reviewsOfProvider.length == 1) {
    averageRatingOfProvider = reviewsOfProvider[0].attributes.rating;
  } else {
    reviewsOfProvider?.map((item, index) => {
      if (index == 0) {
        averageRatingOfProvider = item.attributes.rating;
      } else {
        averageRatingOfProvider = (averageRatingOfProvider + item.attributes.rating) / 2;
      }
    });
  }

  if (reviewsOfCustomer.length == 0) {
    averageRatingOfCustomer = 0;
  } else if (reviewsOfCustomer.length == 1) {
    averageRatingOfCustomer = reviewsOfCustomer[0].attributes.rating;
  } else {
    reviewsOfCustomer?.map((item, index) => {
      if (index == 0) {
        averageRatingOfCustomer = item.attributes.rating;
      } else {
        averageRatingOfCustomer = (averageRatingOfCustomer + item.attributes.rating) / 2;
      }
    });
  }

  if (isReviewTypeProviderSelected) {
    onUpdateAverageRating(Number.isInteger(averageRatingOfProvider) ? averageRatingOfProvider : averageRatingOfProvider.toFixed(1));
  } else {
    onUpdateAverageRating(Number.isInteger(averageRatingOfCustomer) ? averageRatingOfCustomer : averageRatingOfCustomer.toFixed(1));
  }

  let desktopReviewTabs = [];

  if (userType == 'supplier' || userType == 'both') {
    desktopReviewTabs.push(
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle} onClick={() => { onUpdateAverageRating(averageRatingOfProvider) }}>
            <FormattedMessage
              id="ProfilePage.reviewsFromMyCustomersTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeProviderSelected,
        onClick: () => onUpdateShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
      }
    );
  }
  if (userType == 'customer' || userType == 'both') {
    desktopReviewTabs.push(
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle} onClick={() => { onUpdateAverageRating(averageRatingOfCustomer) }}>
            <FormattedMessage
              id="ProfilePage.reviewsAsACustomerTitle"
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeCustomerSelected,
        onClick: () => onUpdateShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
      }
    );
  }

  return (
    <div className={css.mobileReviews}>
      <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

      {isReviewTypeProviderSelected ? (
        <Reviews reviews={reviewsOfProvider} />
      ) : (
        <Reviews reviews={reviewsOfCustomer} />
      )
      }
    </div>
  );
};

export const DesktopReviews = props => {
  const { reviews,
    queryReviewsError,
    user,
    onUpdateAverageRating,
    showReviewsType,
    onUpdateShowReviewsType,
  } = props;

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;

  const userType = user?.attributes?.profile?.protectedData?.userType;

  let averageRatingOfProvider;
  let averageRatingOfCustomer;

  if (reviewsOfProvider.length == 0) {
    averageRatingOfProvider = 0;
  } else if (reviewsOfProvider.length == 1) {
    averageRatingOfProvider = reviewsOfProvider[0].attributes.rating;
  } else {
    reviewsOfProvider?.map((item, index) => {
      if (index == 0) {
        averageRatingOfProvider = item.attributes.rating;
      } else {
        averageRatingOfProvider = (averageRatingOfProvider + item.attributes.rating) / 2;
      }
    });
  }

  if (reviewsOfCustomer.length == 0) {
    averageRatingOfCustomer = 0;
  } else if (reviewsOfCustomer.length == 1) {
    averageRatingOfCustomer = reviewsOfCustomer[0].attributes.rating;
  } else {
    reviewsOfCustomer?.map((item, index) => {
      if (index == 0) {
        averageRatingOfCustomer = item.attributes.rating;
      } else {
        averageRatingOfCustomer = (averageRatingOfCustomer + item.attributes.rating) / 2;
      }
    });
  }

  if (isReviewTypeProviderSelected) {
    onUpdateAverageRating(Number.isInteger(averageRatingOfProvider) ? averageRatingOfProvider : averageRatingOfProvider.toFixed(1));
  } else {
    onUpdateAverageRating(Number.isInteger(averageRatingOfCustomer) ? averageRatingOfCustomer : averageRatingOfCustomer.toFixed(1));
  }

  let desktopReviewTabs = [];

  if (userType == 'supplier' || userType == 'both') {
    desktopReviewTabs.push(
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle} onClick={() => { onUpdateAverageRating(averageRatingOfProvider) }}>
            <FormattedMessage
              id="ProfilePage.reviewsFromMyCustomersTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeProviderSelected,
        onClick: () => onUpdateShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
      }
    );
  }
  if (userType == 'customer' || userType == 'both') {
    desktopReviewTabs.push(
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle} onClick={() => { onUpdateAverageRating(averageRatingOfCustomer) }}>
            <FormattedMessage
              id="ProfilePage.reviewsAsACustomerTitle"
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeCustomerSelected,
        onClick: () => onUpdateShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
      }
    );
  }

  return (
    <div className={css.desktopReviews}>
      <div className={css.desktopReviewsWrapper}>
        <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

        {isReviewTypeProviderSelected ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    </div>
  );
};

export const MainContent = props => {
  const {
    userShowError,
    bio,
    companyName,
    listings,
    queryListingsError,
    reviews,
    queryReviewsError,
    viewport,
    user,
    averageRating,
    onUpdateAverageRating,
    showReviewsType,
    onUpdateShowReviewsType,
    selectedCategory,
    onCategoryChange,
    categories = [],
    actualListings,
  } = props;



  const hasListings = listings.length > 0;
  const hasBio = !!bio;

  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  const scrollToReview = () => {
    const reviewSection = document.getElementById('review-section');
    reviewSection.scrollIntoView({ behavior: 'smooth' });
  }


  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }
  return (
    <div id='reviewHeader'>
      <H2 as="h1" className={css.desktopHeading}>
        <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: companyName }} /> <br />
        {/* <ReviewRating
          rating={averageRating}
          className={css.desktopReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
        <span className={css.averageRating}>{Math.round(averageRating) || 0}</span> */}
      </H2>
      {/* {hasBio && <p className={css.bio}>{bio}</p>} */}

      <div className={listingsContainerClasses}>
        <H4 as="h2" className={css.listingsTitle}>
          <FormattedMessage id="ProfilePage.listingsTitle" values={{ count: hasListings ? listings.length : 0 }} />
        </H4>

        <ul className={css.categories}>
          {categories.map(category => (
            <li key={category}>
              <button onClick={() => onCategoryChange(category)}>
                {category}
              </button>
            </li>
          ))}
        </ul>

        {listings.length > 0 ? (
          <ul className={css.listings}>
            {listings.map(l => (
              <li className={css.listing} key={l.id.uuid}>
                <ListingCard listing={l} showAuthorInfo={false} />
              </li>
            ))}
          </ul>
        ) : (
          <p>No listings found for this category.</p>
        )}
      </div>
    </div>
  );
};



export const ReviewComponent = props => {
  const {
    reviews,
    queryReviewsError,
    user,
    onUpdateAverageRating,
    showReviewsType,
    onUpdateShowReviewsType,
    viewport
  } = props

  const scrollToTop = () => {
    const reviewSection = document.getElementById('reviewHeader');
    reviewSection.scrollIntoView({ behavior: 'smooth' });
  }
  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
  return (
    <div className={css.ratingBlock}>
      <div className={css.reviewSectionContainer}>
        {isMobileLayout ? (
          <MobileReviews
            reviews={reviews}
            queryReviewsError={queryReviewsError}
            user={user}
            onUpdateAverageRating={onUpdateAverageRating}
            showReviewsType={showReviewsType}
            onUpdateShowReviewsType={onUpdateShowReviewsType}
          />
        ) : (
          <DesktopReviews
            reviews={reviews}
            queryReviewsError={queryReviewsError}
            user={user}
            onUpdateAverageRating={onUpdateAverageRating}
            showReviewsType={showReviewsType}
            onUpdateShowReviewsType={onUpdateShowReviewsType}
          />
        )}
      </div>
      <div style={{ marginTop: '14px' }}>
        <Button onClick={scrollToTop} className={css.seeReview} >
          <FormattedMessage id="ProfilePage.backToTop" /></Button>
      </div>
    </div>
  );
}



const ProfilePageComponent = props => {
  const config = useConfiguration();
  const { scrollingDisabled, currentUser, userShowError, user, intl, onCategoryListings, actualListings, ...rest } = props;

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const profileUser = ensureUser(user);
  const isCurrentUser =
    ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
  var { bio, displayName } = profileUser?.attributes?.profile || {};
  if (user?.attributes?.profile?.publicData?.companyName) {
    displayName = user?.attributes?.profile?.publicData?.companyName;
  }

  const schemaTitleVars = { name: displayName, marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'ProfilePage.schemaTitle' }, schemaTitleVars);

  const userType = user?.attributes?.profile?.protectedData?.userType;
  const userMail = user?.attributes?.profile?.protectedData?.email;
  const companyName = user?.attributes?.profile?.publicData?.companyName;
  const phoneNumber = user?.attributes?.profile?.protectedData?.phoneNumber;
  const address = user?.attributes?.profile?.publicData?.location?.selectedPlace?.address;
  const fbLink = user?.attributes?.profile?.publicData?.fbLink;
  const instaLink = user?.attributes?.profile?.publicData?.instaLink;
  const xLink = user?.attributes?.profile?.publicData?.xLink;
  const linkedInLink = user?.attributes?.profile?.publicData?.linkedInLink;

  const profileImage = user?.profileImage?.attributes?.variants["square-small"]?.url;
  const bannerImageBlobUrl = user?.attributes?.profile?.protectedData?.bannerImageBlobUrl;

  const getImageForCategory = (category) => {
    const foundImage = images.find((img) => img.key === category.toLowerCase());
    return foundImage ? foundImage.value : null;
  };

  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = [...new Set(actualListings.map(listing => listing.attributes.publicData.category))];

  const categoryCounts = {};
  actualListings.forEach(listing => {
    const category = listing.attributes.publicData.category;
    if (categoryCounts[category]) {
      categoryCounts[category]++;
    } else {
      categoryCounts[category] = 1;
    }
  });

  const totalCategoryCount = Object.values(categoryCounts).reduce((a, b) => a + b, 0);

  const onSelectCategory = (category) => {
    if (category === 'All') {
      setSelectedCategory('All');
      onCategoryListings(user?.id, config, null);
    } else {
      setSelectedCategory(category);
      onCategoryListings(user?.id, config, category);
    }
  };

  const { listingFields: listingFieldsConfig } = config?.listing || {};
  const { defaultFilters: defaultFiltersConfig, sortConfig } = config?.search || {};

  const [averageRating, setAverageRating] = useState(0);
  // const [selectedCategory, setSelectedCategory] = useState(null);

  const updateRatingValue = (newValue) => {
    setAverageRating(newValue);
  };

  const [showReviewsType, setShowReviewsType] = useState(userType == 'customer' ? REVIEW_TYPE_OF_CUSTOMER : REVIEW_TYPE_OF_PROVIDER);

  const updateShowReviewsType = (newValue) => {
    setShowReviewsType(newValue);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    props.onCategoryListings(userId, config, category);
  };



  const FILTER_DROPDOWN_OFFSET = -14;
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();



  const originMaybe = isOriginInUse(config) ? { origin: viewportCenter } : {};
  const dropNonFilterParams = false;

  const searchParams = {
    // address,
    ...originMaybe,
    // bounds: viewportBounds,
    mapSearch: true,
    ...validFilterParams(rest, listingFieldsConfig, defaultFiltersConfig, dropNonFilterParams),
  };


  const handleSortBy = (urlParam, values) => {

    if (listingFieldsConfig && defaultFiltersConfig) {

      const urlQueryParams = validUrlQueryParamsFromProps({ ...props, config });

      const queryParams = values
        ? { ...urlQueryParams, [urlParam]: values }
        : omit(urlQueryParams, urlParam);
      history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, queryParams));
    } else {
      console.error("listingFieldsConfig or defaultFiltersConfig is undefined");
    }
  }




  const { searchParamsAreInSync, urlQueryParams, searchParamsInURL } = searchParamsPicker(
    typeof location !== 'undefined' ? location.search : null,
    searchParams,
    listingFieldsConfig,
    defaultFiltersConfig,
    sortConfig,
    isOriginInUse(config)
  );

  const validQueryParams = validFilterParams(
    searchParamsInURL,
    listingFieldsConfig,
    defaultFiltersConfig,
    false
  );
  const selectedFilters = validFilterParams(
    validQueryParams,
    listingFieldsConfig,
    defaultFiltersConfig
  );

  const conflictingFilterActive = isAnyFilterActive(
    sortConfig.conflictingFilters,
    validQueryParams,
    listingFieldsConfig,
    defaultFiltersConfig
  );

  if (userShowError && userShowError.status === 404) {
    return <NotFoundPage />;
  }
  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ProfilePage',
        name: schemaTitle,
      }}
    >

      <LayoutSingleColumn
        sideNavClassName={css.aside}
        style={{ backgroundClip: '#FFF' }}
        topbar={<TopbarContainer currentPage="ProfilePage" />}
        sideNav={
          <AsideContent
            user={user}
            isCurrentUser={isCurrentUser}
            companyName={companyName}
            onCategoryListings={onCategoryListings}
            userShowError={userShowError}
            averageRating={averageRating}
            onUpdateAverageRating={updateRatingValue}
            showReviewsType={showReviewsType}
            userMail={userMail}
            config={config}
            onCategoryChange={handleCategoryChange}
            selectedCategory={selectedCategory}
            actualListings={actualListings}
            {...rest}
          />
        }
      // footer={<FooterContainer />}
      >
        {/*<MainContent 
          bio={bio} 
          companyName={companyName} 
          userShowError={userShowError} 
          user={user} 
          averageRating={averageRating} 
          onUpdateAverageRating={updateRatingValue} 
          showReviewsType={showReviewsType} 
          onUpdateShowReviewsType={updateShowReviewsType} 
          onCategoryChange={handleCategoryChange} 
            selectedCategory={selectedCategory}
            actualListings={actualListings}
          {...rest} 
        />*/}
        <div className={css.listingPanel} >


          <div className={css.yourMecSection}>
            <div className={css.yourMachinesBlockLeft}>
              <div className={css.logoImg}>
                <img src={profileImage} />
              </div>
              <p></p>
              <p><b>{displayName}</b></p>
              {/* <p><img src={RATING} width={100}/></p> */}
              {/* <p className={css.member}>Member since 2022</p> */}
              <ReviewRatingRed
                rating={averageRating}
                className={css.desktopReviewRating}
                reviewStarClassName={css.reviewRatingStar}
              />
              <hr className={css.divider} />
              <div className={css.socialLinks}>
                <a href={fbLink} target="_blank" rel="noopener noreferrer">
                  <img src={FB} width={30} alt="Facebook" />
                </a>
                <a href={linkedInLink} target="_blank" >
                  <img src={IN} width={30} alt="LinkedIn" />
                </a>
                <a href={instaLink} target="_blank" >
                  <img src={INSTA} width={30} alt="Instagram" />
                </a>
                <a href={xLink} target="_blank" >
                  <img src={TW} width={30} alt="Facebook" />
                </a>

              </div>
            </div>
            <div className={css.yourMachinesBlockRight}>
              <div className={css.ownerInfo}>
                {/* <img src={bannerImageBlobUrl} width={'100%'} /> */}
              <div className={css.profileImage}>
                <Image
                  src={bannerImageBlobUrl}
                  className={css.imageBlob}
                  alt="Custom Image"
                  style={{
                    width: '1100px',  // Specify your width
                    height: '200px', // Specify your height
                    objectFit: 'cover',  // or 'contain', 'fill', etc.
                    borderRadius: '5%'
                  }}
                />
                </div>
                <h4>Official Information</h4>
                <div className={css.infopSection}>
                  <div className={css.item}>
                    <div className={css.emailDiv}>
                      <img src={MAIL} />
                    </div>
                    <div>
                      <b>Email</b><br></br>
                      <p>{userMail}</p>
                    </div>
                  </div>
                  <div className={css.item}>
                    <div className={css.phoneDiv}>
                      <img src={PHONE} />
                    </div>
                    <div>
                      <b>Phone Number</b>
                      <p>{phoneNumber}</p>
                    </div>
                  </div>
                  <div className={css.item}>
                    <div className={css.addressDiv}>
                      <img src={ADDRESS} />
                    </div>
                    <div>
                      <b>Address</b>
                      <p className={css.address}>{address}</p>
                    </div>
                  </div>
                </div>
              </div>

              <br></br>

              <div className={css.listingCards}>
                <div className={css.headerListing}>
                  <h4 className={css.headingProfile}>My machines ({totalCategoryCount})</h4>
                  {/*<span>
              {sortConfig.active ? (
                <div className={css.sortyByWrapper}>
                 <FormattedMessage id="MainPanelHeader.sortBy" />
                 <SortBy
                sort={validQueryParams[sortConfig.queryParamName]}
                isConflictingFilterActive={!!conflictingFilterActive}
                hasConflictingFilters={!!(sortConfig.conflictingFilters?.length > 0)}
                selectedFilters={selectedFilters}
                onSelect={handleSortBy}
                  showAsPopup
                   mode={mode}
                contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
                />
                </div>
              ) : null}
        </span>*/}
                </div>
                <div className={css.categoryFilter}>
                  <div
                    className={selectedCategory === 'All' ? css.itemsActive : css.items}
                    onClick={() => onSelectCategory('All')}
                  >
                    All ({totalCategoryCount})
                  </div>
                  {categories.map((category, index) => {
                    // const imageSrc = getImageForCategory(category);
                    return (
                      <div
                        key={index}
                        className={selectedCategory === category ? css.itemsActive : css.items}
                        onClick={() => onSelectCategory(category)}
                      >
                        <span>
                          {/* {imageSrc && (
                    <img src={imageSrc} alt={category} className={css.categoryImage} width="30" height="30" />
                  )} */}
                        </span>
                        <span className={css.categoryText}>
                          {category}
                        </span>
                        <span className={css.categoryCount}>
                          ({categoryCounts[category]})
                        </span>
                      </div>
                    );
                  })}
                </div>

                <MainContent
                  bio={bio}
                  companyName={companyName}
                  userShowError={userShowError}
                  user={user}
                  averageRating={averageRating}
                  onUpdateAverageRating={updateRatingValue}
                  showReviewsType={showReviewsType}
                  onUpdateShowReviewsType={updateShowReviewsType}
                  onCategoryChange={handleCategoryChange}
                  selectedCategory={selectedCategory}
                  actualListings={actualListings}
                  {...rest}
                />
              </div>

            </div>

          </div>

          <div className={css.yourMecSection} >
            <div className={css.yourMachinesBlockLeft}>
              <RatingDistributionComponent
                showReviewsType={showReviewsType}
                {...rest}
              />
            </div>
            <div className={css.yourMachinesBlockRight}>
              <div id="review-section">
                <ReviewComponent
                  user={user}
                  onUpdateAverageRating={updateRatingValue}
                  showReviewsType={showReviewsType}
                  onUpdateShowReviewsType={updateShowReviewsType}
                  {...rest}
                />
              </div>
            </div>
          </div>
        </div>


      </LayoutSingleColumn>
      {/*<LayoutSideNavigation
      topbar={<></>}
      sideNav={<RatingDistributionComponent
        showReviewsType={showReviewsType} 
        {...rest}
      />}
      footer={<FooterContainer />}
      >
        <div id="review-section">
        <ReviewComponent
        user={user}
        onUpdateAverageRating={updateRatingValue}
        showReviewsType={showReviewsType} 
        onUpdateShowReviewsType={updateShowReviewsType} 
        {...rest}
        />
        </div>

      </LayoutSideNavigation>*/}


    </Page>
  );
};

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
    actualListingRefs,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);

  const user = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  const actualListings = getMarketplaceEntities(state, actualListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings,
    reviews,
    queryReviewsError,
    actualListings
  };
};

const mapDispatchToProps = dispatch => ({
  onCategoryListings: (userId, config, category) => dispatch(queryUserListings(userId, config, category)),
});


const ProfilePage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;